import axiosInstance from "../axios";
import config from "../config";

export const clearAllRedisDb = async () => {
    return await axiosInstance({
        method: 'POST',
        baseURL: config.api.localApi,
        url: `/flush-redis-db`,
        validateStatus: status => status >= 200 && status < 300,
    })
}